{
    "locale": "de-DE",
    "footer": {
        "service": "Service",
        "essential": "Essenzielles",
        "address": "Adresse",
        "tel": "Telefon",
        "telfax": "Telefax",
        "email": "E-Mail"
    },
    "search": {
        "placeholder": "Beliebigen Begriff eingeben.",
        "headline": "Suche",
        "search": "Suchen",
        "search-for": "Suche nach {search}",
        "search-for-html": "Artikelsuche nach",
        "count-hits": "{count} Treffer",
        "search-entries": "Suchergebnisse"
    },
    "general": {
        "play": "Abspielen",
        "companyName": "Stiftung Familienunternehmen und Politik",
        "share": "Teilen",
        "to-profile": "Zum Profil",
        "more-know": "Mehr erfahren",
        "contact-info": "Kontaktinformationen",
        "topic": "Thema",
        "all-positions": "Alle Positionen",
        "All-news": "Alle Meldungen",
        "no-entries": "Keine Einträge",
        "no-entries-found": "Keine Einträge gefunden",
        "read-more": "Mehr lesen",
        "sfu": "Stiftung Familienunternehmen und Politik",
        "pariser": "Pariser Platz 6a",
        "berlin": "10117 Berlin",
        "country": "Deutschland",
        "back": "Zurück",
        "not-found": "Seite nicht gefunden",
        "load-more": "Mehr laden",
        "more": "Mehr",
        "position": "Position",
        "opinion": "Meinung",
        "vlog": "Vlog",
        "inPress": "In der Presse",
        "pressNotification": "Pressemitteilungen"
    }
}
